<template>

    <v-dialog v-model="dialog" max-width="920px">

        <template v-slot:activator="{ on }">
            <v-btn text v-on="on" class="pa-0 btn-edurent font-weight-regular" color="primary">
                EDUfund Terms and Conditions
            </v-btn>
        </template>

        <v-card class="terms-aditional">
            <div class="modal-close-btn">
                <v-btn icon @click="dialog=false">
                    <v-icon size="18" color="grey">mdi-close</v-icon>
                </v-btn>
            </div>
            <v-card-text class="pa-10">
                <pre>{{page.additional_terms}}</pre>
            </v-card-text>
        </v-card>
    </v-dialog>

</template>

<script>
    export default {
        name: 'AdditionalTerms',
        props: ['page'],
        data() {
          return {
            dialog: false
          }
        }
    }
</script>
<style scoped>

    .terms-aditional {
        border-radius: 10px !important;
    }
    .terms-aditional h2 {
        font-size: 26px !important;
        font-weight: 700;
    }
    .terms-aditional h3 {
        font-size: 20px !important;
        font-weight: 700;
    }
    .terms-aditional h6 {
        font-size: 14px !important;
        font-weight: 400;
    }
    .terms-aditional p {
        font-size: 14px !important;
        font-weight: 400;
    }
    .terms-aditional .v-card__text {
        color: #000;
    }

</style>